module.exports = __webpack_public_path__ + "static/media/Mercedes-Benz1.d371706f.mp3";